module.exports = __webpack_public_path__ + "static/media/maria_joao_gonçalves.8f3aeb4f.jpg";